import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'alert-small', 'AlertSmall', [["path",{"d":"M12 8v4"}],["path",{"d":"M12 16h.01"}]]);